import { marked } from "marked";
import { useMemo } from "react";

/** Renders our own bundled markdown (legal documents); never user input. */
export function Markdown({ text, lang }: { text: string; lang?: string }) {
  const html = useMemo(() => marked.parse(text, { async: false, gfm: true }), [text]);
  return <div className="markdown" lang={lang} dangerouslySetInnerHTML={{ __html: html }} />;
}
